import React from 'react';
import { graphql, StaticQuery } from 'gatsby';
import { connect } from 'react-redux';

import { Button } from 'module-tsl-ui-elements';

import { OpenPose, MenuPose } from '../utils/pose';

import Header from './header';
import NavBlock from './navBlock';

import { OPEN_MENU } from '../state/constants';
import NavSearching from './navSearching';

const Nav = ({ data, openMenu, setOpenMenu, isSearching, searchValue }) => (
  <React.Fragment>
    <OpenPose className="open-nav" initialPose="closed" pose={openMenu ? 'closed' : 'open'}>
      <Button
        type="button"
        theme="tertiary-warning"
        icon="dots"
        onClick={setOpenMenu}
      />
    </OpenPose>
    <StaticQuery
      query={graphql`
        query NavQuery {
          navJson {
            nav {
              name
              path
              navChildren {
                name
                path
              }
            }
          }
          site {
            pathPrefix
          }
        }
      `}
      render={({ navJson: { nav }, site: { pathPrefix } }) => (
        <MenuPose className="l-side" initialPose="open" pose={openMenu ? 'open' : 'closed'}>
          <Header />
          <menu className="l-menu">
            {isSearching
              ? <NavSearching
                  nav={nav}
                  searchValue={searchValue}
                  pathPrefix={pathPrefix}
                />
              : nav.map((navItem, i) => (
                <NavBlock
                  key={navItem.path}
                  to={navItem.path}
                  name={navItem.name}
                  navChildren={navItem.navChildren}
                  pathPrefix={pathPrefix}
                  delay={50 * i}
                />
              ))
            }
          </menu>
        </MenuPose>
      )}
    />
  </React.Fragment>
);

const mapStateToProps = (state) => ({
  openMenu: state.openMenu,
  isSearching: state.isSearching,
  searchValue: state.searchValue,
})

const mapDispatchToProps = (dispatch) => ({
  setOpenMenu: () => dispatch({ type: OPEN_MENU })
})

export default connect(mapStateToProps, mapDispatchToProps)(Nav);
